// start:ng42.barrel
export * from './room-stay-preferences.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/room-stay-preferences/index.ts